<template>
    <div class="row justify-content-center">
        <div class="col-lg-6 card-wrapper metadata">
            

            <card>
                <!-- Card header -->



                <div class="card-body">
                    <!-- Card body -->
                    <div class="row align-items-center blurb">

                        <div class="col-8">
                            <label>Please provide 7 images in jpg format with a resolution of 300dpi</label>
                        </div>

                        <div class="col-4 text-right">
                            <span class="badge badge-info badge-circle text-white" @click="sample_art_hint()">
                                <i class="fa fa-question"></i>
                            </span>
                        </div>

                        


                    <div class="col-md-12">
                    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                        <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">
                            <!-- Input groups with icon -->

    <!-- div class="container p-5">
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6 mt-5">
                <div class="bg-white p-5 rounded shadow-sm border">
                    <div class="dropzone d-block">
                        <label for="files" class="dropzone-container">
                            <div class="file-icon"><i class="fa-solid fa-file-circle-plus text-primary"></i></div>
                            <div class="text-center pt-3 px-5">
                                <p class="w-80 h5 text-dark fw-bold">Drag your documents, photos or videos here to start uploading.</p>
                                <div class="hr-sect">or</div>
                                <button class="btn btn-primary mb-2">Browse Files</button>
                            </div>
                        </label>
                        <input id="files" name="files[]" type="file" class="file-input" />
                    </div>
                </div>
            </div>
        </div>
    </div -->

    
                            <b-row>

                                <b-col md="12">
                                    <dropzone-file-upload v-model="inputs.fileMultiple" multiple
                                        :options="sample_art_dz.options"
                                        :url="sample_art_dz.url" 
                                        v-on:complete="dz_complete" 
                                        v-on:success="dz_success" 
                                        v-on:addedfile="dz_added" 
                                        v-on:error="dz_error" 
                                        v-on:queuecomplete="dz_queuecomplete"
                                    ></dropzone-file-upload>
                                        
                                </b-col>

                            </b-row>

                            <b-row>

                                <b-col md="12">
                                    
                                    <b-list-group v-for="(image, index) in currentPhotoBookImages" v-bind:key="index" class="list-group dz-preview dz-preview-multiple list-group-lg list-group-flush">

                                        <dz-list-group-item :url="null" :img="image" :id="image.id" :num="index" @image_deleted="image_deleted"></dz-list-group-item>

                                    </b-list-group>

                                </b-col>

                            </b-row>


                            

                            <!-- div class="btn-wrapper text-center">

                                <base-button type="primary" class="btn btn-danger" @click="onCancel">
                                    <span class="btn-inner--text">Back</span>
                                </base-button>

                                <base-button type="primary" class="btn btn-success" @click="onProceed"
                                    :disabled="mayProceed">
                                    <span class="btn-inner--text">Next</span>
                                </base-button>

                            </div -->

                        </form>
                    </validation-observer>
                </div>
                </div>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
import DzListGroupItem from '../../../cscomponents/elements/DzListGroupItem';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
    name: 's04',
    components: {
        DropzoneFileUpload,
        DzListGroupItem,
        [Tooltip.name]: Tooltip
    },
    data() {
        return {
            sample_art_dz: {
                options: {
                    type: Object,
                    autoProcessQueue: true,
                    uploadMultiple: false,
                    parallelUploads: 1,
                    addRemoveLinks: false,
                    acceptedFiles: 'image/*,application/pdf',
                    maxFiles: 3,
                    maxFilesize: 1000,
                    disablePreviews: true,
                    timeout: 1800000,
                    paramName: "[photo_book][photo_book_images][temp_image]",
                    params: {
                        '[photo_book][photo_book_images][imagetype]': 'interiorreq',
                    },
                    headers: {
                        "Authorization": 'Bearer ' + localStorage.token,
                    }
                },
                url: '',
            },
            ims: [],
            inputs: {
                fileSingle: [],
                fileMultiple: []
            },
        };
    },
    methods: {
        dzUrl(){
            return this.$image_host + '/api/v1/spa/photo_books/' + this.currentPhotoBook.id + '/photo_book_image';
        },
        buildUrl(image){
            console.log(image)
            let ht = this.$image_host+image.image.medium.url;
            return ht
        },
        dz_added(data){
            console.log("ADDED"+data);
        },
        // dropzone part
        dz_complete(data){
            this.allDataValidated();
        },
        dz_success(data){
            console.log(data.xhr.response);
            this.currentPhotoBookImages.push(JSON.parse(data.xhr.response));
            this.allDataValidated();
        },
        dz_error(data){
            swal.fire({
                title: 'Please check requirements:',
                text: this.build_error_text(data.xhr.response),
                timer: 5000,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-warning',
                icon: 'warning'
            });
        },
        dz_queuecomplete(data){
            console.log("QUEUECOMPLETE");
            //console.log(data);
        },
        build_error_text(response){
            let err = JSON.parse(response);
            return err.errors;
        },
        image_deleted(){
            this.$store.dispatch('fetchPhotoBookImages', { pbid: this.currentPhotoBook.id, imagetype: "interiorreq" });
        },
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
            console.log("checking images count: "+this.currentPhotoBookImages.length);
            if (
                this.currentPhotoBookImages.length == 7
            ) {
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.uploads_finished_next_step();
                return true;

            }
            this.$emit('denyProceed');
            return false;
        },
        sample_art_hint(){  
            swal.fire({
                title: 'Your preorder sample art',
                text: 'Your uploaded pictures will be used to create several mockups for the preorder campaign',
                icon: 'info',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info'
            });
        },        
        image_format_hint(){  
            swal.fire({
                title: 'Format & quality',
                text: 'The images you upload have to be 300dpi resolution, jpeg format.',
                icon: 'info',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-pink'
            });
        },
        uploads_finished_next_step(){  
            swal.fire({
                title: 'Well done!',
                text: 'Thank you for submitting your material. We will get back to you with three cover proposals. In the meantime check your dashboard for book promotion tips and other information.',
                icon: 'info',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-pink',
                confirmButtonText: 'To dashboard',
                allowOutsideClick: false,

            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch('photoBookNextStep');
                    this.$router.push('/#/artist/home');
                   /* this.$store.dispatch('photoBookNextStep');
                        this.close();
                   */
                }
            })
            
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
            currentPhotoBookImages: 'currentPhotoBookImages',
        }),
        mayProceed: function () {
            return !this.allDataValidated();
        },
    },
    watch: {
        currentPhotoBookImages(newValue, oldValue) {
            console.log('queryParameter currentPhotoBookImages changed from: ' + oldValue + ' -> ' + newValue);
            this.allDataValidated();
        },
    },
    mounted() {
        this.$store.dispatch('fetchPhotoBookImages', { pbid: this.currentPhotoBook.id, imagetype: "interiorreq" });
        this.sample_art_dz.url = this.dzUrl();
        this.$emit('denyProceed');


        this.image_format_hint();
        
    },
};
</script>
<style>
          .dropzone {
            /*
            border: dashed 4px #ddd !important ;
            background-color: #f2f6fc;
            */
            width: 100%;
            border-radius: 15px;
        }
    
        .dropzone .dropzone-container {
            padding: 2rem 0;
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #8c96a8;
            z-index: 20;
        }
    
        .dropzone .file-input {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            visibility: hidden;
            cursor: pointer;
        }

        .file-icon{
            font-size: 60px;
        }
        .hr-sect {
            display: flex;
            flex-basis: 100%;
            align-items: center;
            margin: 8px 0px;
        }
        .hr-sect:before,
        .hr-sect:after {
            content: "";
            flex-grow: 1;
            background: #ddd;
            height: 1px;
            font-size: 0px;
            line-height: 0px;
            margin: 0px 8px;
        }

        .dz-message{
            z-index: 999;
            padding: 5rem 1rem;
            cursor: pointer;
            transition: all .15s ease;
            text-align: center;
            color: #8898aa;
            border: 1px dashed #dee2e6;
            border-radius: .375rem;
            background-color: #fff;
            order: -1;
        }
        
    </style>
    